var baseurl = "https://mindi-unkeyed-delta.ngrok-free.dev/";
var geoserver_url = "http://localhost:8080/"; //
var image_url = "https://gis.orangecurrent.com/img/"; //
var kpi_report_url = "http://194.163.171.206:30040/reports/pages/kpi-report";
var activity_report_url = "http://194.163.171.206:30040/activityreport/pages/activity-report";
var employee_image_url = "https://uat-topupp.orangecurrent.com/uploads/c120x120/"; //
var Feeder_service_Url = "https://energy.orangecurrent.com/";
var Trasformer_Service_Url = "https://transformers.orangecurrent.com/transformers-service/";

export {
  baseurl,
  geoserver_url,
  kpi_report_url,
  activity_report_url,
  image_url,
  employee_image_url,
  Feeder_service_Url,
  Trasformer_Service_Url,
};
